import {Button, message, Modal, Result} from "antd"
import {EditOutlined} from "@ant-design/icons"
import React, {useEffect, useState} from "react"
import {useGroupBuyingContext} from "../store/useGroupBuyingContext"
import {postGrouponState} from "../../../api/groupon"

const GroupBuyingDelete = ({ grouponId }) => {
    const [isState, setIsState] = useState("关闭")
    const [isShow, setIsShow] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [customStyle, setCustomStyle] = useState({ background: "#52c41a", borderColor: "#52c41a", color: "#fff" })

    const { grouponSettingState,grouponListState } = useGroupBuyingContext()

    useEffect(() => {
        setIsState(grouponSettingState.data.canCustomerConsumeGroupon ? "关闭" : "开启")
        setCustomStyle(grouponSettingState.data.canCustomerConsumeGroupon ?  { background: "#99a3a4", borderColor: "#99a3a4", color: "#fff" } : { background: "#52c41a", borderColor: "#52c41a", color: "#fff" } )
    }, [grouponSettingState.data.canCustomerConsumeGroupon])

    const handleChangeCanCustomerConsumeGroupon = async () => {
        setIsLoading(true)
        const setting = grouponSettingState.data
        const data = {
            ...setting,
            canCustomerConsumeGroupon: !setting.canCustomerConsumeGroupon
        }
        await postGrouponState(data).then(res => {
            if (res.status !== 1) {
                message.error(`修改俱乐部设置失败：${res.detail}`)
            } else {
                message.success('修改成功，自助团购核销已' + (setting.canCustomerConsumeGroupon ? '关闭' : '开启') + '！')
            }
        }).finally(async () => {
            setIsLoading(false)
            setIsShow(false)
            await grouponListState.reFetch()
            await grouponSettingState.reFetch()
        })
    }


    return (
        <div>
            <Button icon={<EditOutlined />} onClick={() => { setIsShow(true) }} style={customStyle}>
                {isState}自助团购核销
            </Button>
            <Modal open={isShow} onCancel={() => { setIsShow(false) }} onOk={handleChangeCanCustomerConsumeGroupon} confirmLoading={isLoading}>
                <Result title={`确定要${isState}自助团购核销吗?`} status={"warning"} />
            </Modal>
        </div>
    )
}

export default GroupBuyingDelete


// WEBPACK FOOTER //
// ./src/containers/GroupBuyingList/components/GroupBuyingVerification.js